import React from 'react';
import { LandingSearchForm } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { types as sdkTypes } from '../../../../util/sdkLoader';
import { useLocation } from 'react-router-dom';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';

import css from './SectionHero.module.css';
import { formatDateRangeForTimezone } from '../../../../util/genericHelpers';
import { parse } from '../../../../util/urlHelpers';

const { LatLng, LatLngBounds } = sdkTypes;
function RenderLandingPageSectionHero(props) {
  const { isTopbarSearch, showTopbarSearch } = props;
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const { keywords: keywordsFromURL } = parse(location.search || '');
  const initialValues = {
    keywords: keywordsFromURL != null ? `${keywordsFromURL}` : '',
  };

  const handleSubmit = values => {
    const { keywords = null, location = null, dates } = values || {};

    const searchQuery = {};
    if (keywords) searchQuery.keywords = keywords;
    const { search = 'United States', selectedPlace } = location || {};

    const defaultBounds = new LatLngBounds(
      new LatLng(62.198642531, -81.98187937),
      new LatLng(12.40936803, -125.48773874)
    );

    const { bounds = defaultBounds } = selectedPlace || {};
    Object.assign(searchQuery, { address: search, bounds });

    const dateRange = formatDateRangeForTimezone(dates);
    if (dateRange) {
      searchQuery.dates = dateRange;
    }

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };

  return (
    <LandingSearchForm
      rootClassName={css.landingSearchForm}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isTopbarSearch={isTopbarSearch}
      showTopbarSearch={showTopbarSearch}
    />
  );
}

export default RenderLandingPageSectionHero;
